import React, { useEffect, useState } from "react";
import {
    Layout,
    Space,
    PageHeader,
    message,
    Button,
    Card,
    Input,
  } from "antd";
import MenuSetting from "../../../services/menuSetting";

const OrderSettings = () => {
    const { Content } = Layout;
    const [settingsList, setSettingsList ] = useState();

    const getAllSettings =() => {
        MenuSetting.getRestaurentSettings().then((res)=>{
            if(res?.restaurant_id){
                setSettingsList(res);
            } 
        });
    };

    useEffect(()=>{
        getAllSettings();
    },[]);

    const updateSettings = async(event,key)=>{
        setSettingsList({...settingsList, [key]: Number(event.target.value)})
    };

    const onsave = async()=>{
        let payload = {...settingsList};
        delete payload.id;
        delete payload.restaurant_id;
        delete payload.created_at;
        delete payload.updated_at;
        MenuSetting.saveRestaurentSettings(payload).then((res)=>{
            if(res){
                message.success('Updated successfully');
                getAllSettings()
            } 
        });
    };
    return <Layout className="u-page-layout pos-layout">
    <Content className="page-padding">
      <Space direction="vertical" style={{width: "100%" }}>
        <PageHeader title="Order Settings" style={{ background: "#f0f2f5" }} />
        <div className="pos-setup">
        <Card className="pos-card">
            <div className="card-content">
                <div>
                    <div className="card-heading mb-2">Base Preparation Time</div>
                    <div className="content_item mb-2">
                        <label className="info_label">Delivery:</label>
                        <Input className="slots-input" 
                            value={settingsList?.est_prep_mins_for_delivery}
                            onChange={(event) => updateSettings(event, "est_prep_mins_for_delivery")}
                            type="number" suffix="min" />
                    </div>
                    <div className="content_item mb-1">
                        <label className="info_label">Takeout:</label>
                        <Input className="slots-input" 
                            value={settingsList?.est_prep_mins_for_takeout}
                            onChange={(event) => updateSettings(event, "est_prep_mins_for_takeout")}
                            type="number" suffix="min" />
                    </div>
                </div>
            </div>
          <Button type="primary" className='field_save_btn' 
            style={{ width:"180px", height: "35px", marginBottom: "10px", marginTop: 10 }} 
            onClick={onsave}> Save </Button>
        </Card>
        </div>
      </Space>
    </Content>
  </Layout>
};
export default OrderSettings;
